(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nenes-consider-cta"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('nenes-consider-cta')) return;
    class NenesConsiderCTA extends HTMLElement {
      static activeDialogs = new Set();
      static privacyPromise;
      static updateScrollLock() {
        const locked = this.activeDialogs.size > 0;
        document.documentElement.classList.toggle('ncs-modal-open', locked);
        document.body.classList.toggle('ncs-modal-open', locked);
      }
      static preparePrivacy() {
        if (window.Shopify && window.Shopify.customerPrivacy) return Promise.resolve();
        if (this.privacyPromise) return this.privacyPromise;
        this.privacyPromise = new Promise(resolve => {
          if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') { resolve(); return; }
          const timer = setTimeout(resolve, 1500);
          try {
            window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => { clearTimeout(timer); resolve(); });
          } catch (_) { clearTimeout(timer); resolve(); }
        });
        return this.privacyPromise;
      }
      connectedCallback() {
        if (this.abortController) return;
        this.trigger = this.querySelector('[data-ncs-open]');
        this.dialog = this.querySelector('[data-ncs-dialog]');
        this.closeButton = this.querySelector('[data-ncs-close]');
        if (!this.trigger || !this.dialog || !this.closeButton) {
          if (!this.readyFrame) this.readyFrame = requestAnimationFrame(() => {
            this.readyFrame = null;
            if (this.isConnected) this.connectedCallback();
          });
          return;
        }
        this.abortController = new AbortController();
        const options = { signal: this.abortController.signal };
        this.trigger.addEventListener('click', () => this.open(), options);
        this.closeButton.addEventListener('click', () => this.dialog.close(), options);
        this.dialog.addEventListener('click', e => {
          if (e.target !== this.dialog) return;
          const rect = this.dialog.getBoundingClientRect();
          if (e.clientX < rect.left || e.clientX > rect.right || e.clientY < rect.top || e.clientY > rect.bottom) this.dialog.close();
        }, options);
        this.dialog.addEventListener('close', () => {
          this.trigger.setAttribute('aria-expanded', 'false');
          NenesConsiderCTA.activeDialogs.delete(this);
          NenesConsiderCTA.updateScrollLock();
          if (this.isConnected) this.trigger.focus({ preventScroll: true });
        }, options);
        if (this.dataset.ncsMeta === 'true' || this.dataset.ncsGas === 'true') NenesConsiderCTA.preparePrivacy();
        if (this.dataset.ncsAnimate === 'true') {
          this.trigger.addEventListener('mouseenter', () => this.animateButton(), options);
          if ('IntersectionObserver' in window) {
            this.observer = new IntersectionObserver(entries => {
              if (entries.some(entry => entry.isIntersecting)) { this.animateButton(); this.observer.disconnect(); }
            }, { threshold: 0.25 });
            this.observer.observe(this.trigger);
          }
        }
      }
      disconnectedCallback() {
        if (this.readyFrame) cancelAnimationFrame(this.readyFrame);
        this.readyFrame = null;
        if (this.dialog && this.dialog.open) this.dialog.close();
        if (this.abortController) this.abortController.abort();
        if (this.observer) this.observer.disconnect();
        clearTimeout(this.animationTimer);
        this.abortController = null;
        NenesConsiderCTA.activeDialogs.delete(this);
        NenesConsiderCTA.updateScrollLock();
      }
      animateButton() {
        if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        this.trigger.classList.remove('ncs-is-animating');
        void this.trigger.offsetWidth;
        this.trigger.classList.add('ncs-is-animating');
        clearTimeout(this.animationTimer);
        this.animationTimer = setTimeout(() => this.trigger.classList.remove('ncs-is-animating'), 750);
      }
      open() {
        if (this.dialog.open || typeof this.dialog.showModal !== 'function') return;
        this.dialog.showModal();
        this.trigger.setAttribute('aria-expanded', 'true');
        NenesConsiderCTA.activeDialogs.add(this);
        NenesConsiderCTA.updateScrollLock();
        this.closeButton.focus({ preventScroll: true });
        void this.track();
      }
      async permitted(method) {
        await NenesConsiderCTA.preparePrivacy();
        try {
          const privacy = window.Shopify && window.Shopify.customerPrivacy;
          return Boolean(privacy && typeof privacy[method] === 'function' && privacy[method]());
        } catch (_) { return false; }
      }
      async track() {
        const customer = this.dataset.ncsCustomer || 'unspecified';
        const discount = this.dataset.ncsDiscount || '';
        const pageType = this.dataset.ncsPage || '';
        if (this.dataset.ncsMeta === 'true' && await this.permitted('marketingAllowed')) {
          const eventName = this.dataset.ncsEvent || 'SHARRMini_Considering';
          if (typeof window.fbq === 'function') {
            const params = {};
            if (customer !== 'unspecified') params.customer_type = customer;
            if (discount) params.discount = discount;
            if (pageType) params.page_type = pageType;
            try { window.fbq('trackCustom', eventName, params); } catch (_) {}
          }
        }
        if (this.dataset.ncsGas === 'true' && this.dataset.ncsGasUrl && await this.permitted('analyticsProcessingAllowed')) {
          try {
            const url = new URL(this.dataset.ncsGasUrl);
            if (url.protocol !== 'https:' || url.hostname !== 'script.google.com' || !/^\/macros\/s\/[^/]+\/exec$/.test(url.pathname)) return;
            url.searchParams.set('choice', '悩み中');
            if (customer !== 'unspecified') url.searchParams.set('customer_type', customer === 'repeat' ? 'ご愛用者' : '新規');
            if (discount) url.searchParams.set('discount', discount);
            if (pageType) url.searchParams.set('page_type', pageType);
            fetch(url.href, { method: 'GET', mode: 'no-cors', keepalive: true }).catch(() => {});
          } catch (_) {}
        }
      }
    }
    customElements.define('nenes-consider-cta', NenesConsiderCTA);
  })();

  } catch(e) { console.error(e); }
})();
})();
